import { PublishStoryComponentTextModel } from '../../../../Common/Dialogs/models/publish-story-component-text.model';

export class PublishArticleComponentText implements PublishStoryComponentTextModel {
    confirmationInformation: string = 'Submit for Review';
    authorTitle: string = 'Author';
    iAgree: string = 'I agree';
    agreePublish: string = 'Agree and Submit';
    cancel: string = 'Cancel';
    confirmationMessage: string = 'Are you sure that you want to submit this press release for review?';
    confirmation: string = 'Confirmation';
    publish: string = 'Submit for review';
    headerTitle: string = 'Newswire';
    headerSubTitle: string = 'Almost Ready!';
    headerContent: string = 'Please review and verify the following information:';
    publishLoader: string = 'SUBMITTING ...';
}
